<template>
  <v-container fluid class="ventas__container">
    <v-data-table
      mobile-breakpoint="900"
      class="elevation-1"
      color="primary"
      :options="dataOptions"
      :footer-props="footerProps"
      :calculate-widths="true"
      :headers="ventasTblHeaders"
      :items="ventas"
      :loading="showTableLoadingMsg"
      loading-text="Cargando... Espera por favor..."
      no-data-text="Ninguna venta para mostrar"
      no-results-text="Ninguna venta encontrada para la búsqueda"
      :search="ventasSearch"
      :expanded.sync="expanded"
      :single-expand="singleExpand"
      show-expand
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Ventas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="ventasSearch"
            append-icon="mdi-magnify"
            hide-details
            label="Buscar venta"
            class="mx-4"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="dateRangeText"
            label="Ver para el rango fechas"
            prepend-icon="mdi-calendar"
            readonly
            @click="openDatePickerModal(context)"
          ></v-text-field>
          <v-dialog v-model="editSaleDialog" max-width="650px">
            <v-card>
              <v-card-title>
                <span class="headline">Editar Venta</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row dense>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        outlined
                        v-model="cliente"
                        readonly
                        label="Cliente*"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        outlined
                        v-model="vendedor"
                        readonly
                        label="Vendedor*"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        v-model="statusEntrega"
                        :items="estadosDeEntrega"
                        label="Entregado?*"
                        class="user-input"
                        required
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        v-model="statusPago"
                        :items="estadosDePago"
                        label="Status de Pago*"
                        class="user-input"
                        required
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        v-model="formaPago"
                        :items="formasDePago"
                        label="Forma de Pago*"
                        class="user-input"
                        required
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        prefix="$"
                        readonly
                        v-model="total"
                        label="Total*"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        prefix="$"
                        v-model="abono"
                        label="Abonado*"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        readonly
                        prefix="$"
                        v-model="cSaldo"
                        label="Saldo*"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="10" offset-md="1">
                      <v-menu
                        ref="dateMenu"
                        v-model="dateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="fechaEntrega"
                            label="Fecha de entrega"
                            hint="año - mes - día"
                            persistent-hint
                            prepend-icon="mdi-calendar-clock"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="fechaEntrega"
                          no-title
                          @input="dateMenu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="12" md="10" offset-md="1">
                      <v-time-picker
                        v-model="time"
                        :landscape="$vuetify.breakpoint.mdAndUp"
                        full-width
                        type="month"
                      ></v-time-picker>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <template item.action="{ item }">
                  <v-btn color="default darken-1" text @click="closeEditDialog"
                    >Cancelar</v-btn
                  >
                  <v-btn color="green darken-1" dark @click="saveEdited()"
                    >Guardar</v-btn
                  >
                </template>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="saving" hide-overlay persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                Guardando cambios
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
          <NavDatePickerModal
            :context="context"
            @dateRangeSelected="fetchSalesInDateRange"
          />
        </v-toolbar>
      </template>
      <template v-slot:item.index="{ item }">
        <span
          >{{
            ventas
              .map(function (x) {
                return x.id;
              })
              .indexOf(item.id) + 1
          }}
        </span>
      </template>
      <template v-slot:item.id="{ item }">
        <v-chip color="default">
          <strong>
            {{ `${item.id}` }}
          </strong>
        </v-chip>
      </template>
      <template v-slot:item.id_cliente="{ item }">
        <v-chip color="default">
          <strong>
            {{ item.nombreCliente }}
          </strong>
        </v-chip>
      </template>
      <template v-slot:item.total="{ item }">
        <strong> ${{ formatDecimal(item.total) }} </strong>
      </template>
      <template v-slot:item.saldo="{ item }">
        <v-chip
          :color="item.saldo > 0 ? 'red' : 'default'"
          :text-color="item.saldo > 0 ? 'white' : 'black'"
        >
          ${{ item.saldo > 0 ? formatDecimal(item.saldo) : item.saldo }}
        </v-chip>
      </template>
      <template v-slot:item.status_pago="{ item }">
        {{ item.status_pago === "cobrar" ? "por cobrar" : item.status_pago }}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td style="text-align: center" :colspan="headers.length">
          <div style="display: flex; justify-content: center">
            <div style="display: flex">
              <div style="margin-right: 5px"><strong>CODIGO:</strong></div>
              <div>
                <strong>{{ item.codigo }}</strong>
              </div>
            </div>
            <v-divider class="mx-4" vertical></v-divider>
            <div style="display: flex; justify-content: center">
              <div style="margin-right: 5px">ACTUALIZADA EL DÍA:</div>
              <div>{{ item.humanFechaActualizacion }}</div>
            </div>
          </div>
        </td>
      </template>
      <template v-slot:item.details="{ item }">
        <v-icon @click="showDetails(item)">mdi-magnify</v-icon>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="ventas__table__actions-col">
          <ConfirmActionBtn
            cssClass="mr-3"
            size="x-small"
            :XSmBtn="true"
            :disabled="false"
            icon="mdi-printer"
            :hoverable="true"
            hoverColor="red"
            action="RE_PRINT_INVOICE"
            tooltip="Re-imprimir ticket"
            :invoice="item"
            @btnAction="printItem(item, $event)"
          />
          <v-btn class="mr-2" icon x-small @click="editItem(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon x-small color="red" @click="deleteItem(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <InvoiceDetails />
  </v-container>
</template>

<script>
import InvoiceDetails from "../components/InvoiceDetails.vue";
import ConfirmActionBtn from "../components/ConfirmActionBtn.vue";
import NavDatePickerModal from "../components/NavDatePickerModal.vue";

import printTicketMixin from "../mixins/mixin-print-ticket";
import dataTableMixin from "../mixins/mixin-data-tables";
// const { getVentasByDateRange, updateSaleByID, deleteSaleByID } =
//   api.services.ventasService;
// const { getClienteByID } = api.services.clientesService;
// const { getUsuarioByID } = api.services.usuariosService;

import { mapGetters, mapActions } from "vuex";
import * as Utils from "@/services/utils";

export default {
  name: "Ventas",
  components: {
    InvoiceDetails,
    ConfirmActionBtn,
    NavDatePickerModal,
  },
  mixins: [printTicketMixin, dataTableMixin],
  data: function () {
    return {
      context: "VENTAS",
      sales: [],
      ventasSearch: "",
      expanded: [],
      footerProps: {
        "items-per-page-text": "Filas a mostrar",
        "items-per-page-options": [5, 10, 30, 50, 100, -1],
      },
      dataOptions: {
        sortBy: ["id"],
        sortDesc: [true],
      },
      singleExpand: true,
      dateMenu: false,
      time: null,
      cliente: "",
      vendedor: "",
      formaPago: "",
      statusPago: "",
      statusEntrega: "",
      fechaEntrega: new Date().toISOString().substr(0, 10),
      total: 0,
      abono: 0,
      saldo: 0,
      formasDePago: ["Efectivo", "TC", "TD"],
      estadosDePago: ["Pagado", "Pendiente"],
      estadosDeEntrega: ["Entregada", "Recibida"],
      defaultItem: {},
      editedSale: {},
      editSaleDialog: false,
      savingSaleEdit: false,
      calculateWidths: true,
      ventasTblHeaders: [
        {
          text: "#",
          align: "right",
          sortable: true,
          value: "index",
          width: "1%",
        },
        {
          text: "Folio",
          align: "left",
          sortable: true,
          value: "id",
          width: "1%",
        },
        {
          text: "Cliente",
          align: "left",
          sortable: true,
          value: "nombreCliente",
          width: "10%",
        },
        {
          text: "Vendedor",
          align: "left",
          sortable: true,
          value: "nombreVendedor",
        },
        {
          text: "Forma Pago",
          align: "left",
          sortable: true,
          value: "metodo_pago",
          width: "8%",
        },
        {
          text: "Status Pago",
          align: "left",
          sortable: true,
          value: "status_pago",
          width: "8%",
        },
        {
          text: "Total",
          align: "left",
          sortable: true,
          value: "total",
          width: "1%",
        },
        {
          text: "Por pagar",
          align: "left",
          sortable: true,
          value: "saldo",
          width: "1%",
        },
        {
          text: "Recibido",
          align: "left",
          sortable: true,
          value: "humanFechaRecepcion",
        },
        {
          text: "Entregar el",
          align: "left",
          sortable: true,
          value: "humanFechaEntrega",
        },
        {
          text: "Cargos",
          align: "left",
          sortable: false,
          value: "details",
        },
        { text: "Más", value: "data-table-expand" },
        {
          text: "Admin",
          align: "left",
          sortable: false,
          value: "action",
          width: "10%",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["user", "demoVentas"]),
    saving: {
      get: function () {
        return this.savingSaleEdit;
      },
      set: function (payload) {
        this.savingSaleEdit = payload;
      },
    },
    ventas: {
      get: function () {
        return this.sales;
      },
      set: function (payload) {
        this.sales = payload;
      },
    },
    cAbono: {
      get: function () {
        return this.abono;
      },
      set: function (abono) {
        this.abono = abono;
        this.updateSaldo(abono);
      },
    },
    cSaldo() {
      return this.saldo;
    },
    editedSaleData: {
      get: function () {
        return this.editedSale;
      },
      set: function (payload) {
        this.editedSale = payload;
      },
    },
  },
  methods: {
    ...mapActions([
      "setItemToShow",
      "showInvoiceDetailDialog",
      "showLoadingIndicator",
      "getUsuarioDemoByID"
    ]),
    getVentasByDateRange(){
      const ventas = this.demoVentas;
      return new Promise(function(resolve, reject){
        resolve(ventas);
        const error = {
          msg: "An error occurred"
        };
        reject(error);
      });
    },
    updateSaleByID(){},
    deleteSaleByID(){},
    getClienteByID(){},
    getUsuarioByID(id){
      const usuarioDemo = this.getUsuarioDemoByID(id);
      console.log("[usuarioDemo] ",usuarioDemo);
      return usuarioDemo;
    },
    showDetails(item) {
      this.setItemToShow(item);
      this.showInvoiceDetailDialog(true);
    },
    nombreVendedor(id) {
      const usuario = this.getUsuarioByID(id);
      return usuario
        ? `${usuario.nombre ? usuario.nombre : ""} ${
            usuario.apellido ? usuario.apellido : ""
          }`
        : "";
    },
    nombreCliente(id) {
      const cliente = this.getClienteByID(id);
      return cliente
        ? `${cliente.nombre} ${cliente.apellido ? cliente.apellido : ""}`
        : "";
    },
    formatDecimal(num) {
      return Utils.formatDecimal(num);
    },
    humanDateFormat: (fecha) => {
      return Utils.humanDateFormat(fecha, "es");
    },
    printItem(item) {
      this.printBillTicket(item.codigo);
    },
    editItem(item) {
      this.populateEditDialog(item);
      this.editSaleDialog = true;
    },
    populateEditDialog(item) {
      this.editedSaleData = item;
      this.cliente = this.nombreCliente(item.id_cliente);
      this.vendedor = this.nombreVendedor(item.id_vendedor);
      this.statusPago = item.status_pago;
      this.statusEntrega = item.status_er.replace(/^\w/, (c) =>
        c.toUpperCase()
      );
      this.fechaEntrega = item.fecha_entrega.substring(0, 10);
      this.time = item.fecha_entrega.substring(11, 16);
      this.formaPago = item.metodo_pago;
      this.total = item.total;
      this.saldo = item.saldo;
      this.cAbono = item.abono;
    },
    deleteItem(item) {
      const index = this.ventas.indexOf(item);
      const confirmation =
        confirm(`Seguro quieres borrar la venta: ${item.id} ${item.codigo}?`) &&
        this.ventas.splice(index, 1);
      const { id } = item;
      if (confirmation) this.deleteSaleByID(id);
    },
    closeEditDialog() {
      this.editSaleDialog = false;
    },
    saveEdited() {
      this.showLoadingIndicator(true);
      this.fillDataObject();
      this.updateSaleByID(this.editedSaleData).then((info) => {
        if (info) {
          this.resetEditedSale();
          this.fetchSales();
          this.showLoadingIndicator(false);
          this.closeEditDialog();
        }
      });
    },
    fillDataObject() {
      this.editedSaleData.status_er = this.statusEntrega;
      this.editedSaleData.status_pago = this.statusPago;
      this.editedSaleData.forma_pago = this.formaPago;
      this.editedSaleData.fecha_entrega = `${this.fechaEntrega} ${this.time}`;
      this.cAbono = this.abono;
      this.editedSaleData.abono = this.cAbono;
    },
    updateSaldo() {
      this.editedSaleData.saldo = this.total - this.abono;
    },
    resetEditedSale() {
      this.editedSaleData = {};
    },
    defineHeaders() {
      const { perfil } = this.user;
      if (perfil != "Administrador") {
        this.ventasTblHeaders = [
          {
            text: "#",
            align: "right",
            sortable: true,
            value: "index",
            width: "1%",
          },
          {
            text: "Folio",
            align: "left",
            sortable: true,
            value: "id",
            width: "1%",
          },
          {
            text: "Cliente",
            align: "left",
            sortable: true,
            value: "nombreCliente",
            width: "10%",
          },
          {
            text: "Vendedor",
            align: "left",
            sortable: true,
            value: "nombreVendedor",
          },
          {
            text: "Forma Pago",
            align: "left",
            sortable: true,
            value: "metodo_pago",
            width: "8%",
          },
          {
            text: "Total",
            align: "left",
            sortable: true,
            value: "total",
            width: "1%",
          },
          {
            text: "Por pagar",
            align: "left",
            sortable: true,
            value: "saldo",
            width: "1%",
          },
          {
            text: "Recibido",
            align: "left",
            sortable: true,
            value: "humanFechaRecepcion",
          },
          {
            text: "Entregar el",
            align: "left",
            sortable: true,
            value: "humanFechaEntrega",
          },
          {
            text: "Cargos",
            align: "left",
            sortable: false,
            value: "details",
          },
          { text: "Más", value: "data-table-expand" },
        ];
      }
    },
    fetchSales() {
      const self = this;
      const [startDate, endDate] = this.selectedDates;
      const startDateTimeStr = `${startDate} ${this.startTime}`;
      const endDateTimeStr = `${endDate} ${this.endTime}`;
      this.getVentasByDateRange(startDateTimeStr, endDateTimeStr).then((ventas) => {
        self.ventas = ventas;
        self.showTableLoadingMsg = false;
      });
    },
    fetchSalesInDateRange(dates) {
      const self = this;
      const startDate = dates[0];
      const endDate = dates && dates[1] ? dates[1] : startDate;
      const startDateTimeStr = `${startDate} ${this.startTime}`;
      const endDateTimeStr = `${endDate} ${this.endTime}`;
      this.showTableLoadingMsg = true;
      this.getVentasByDateRange(startDateTimeStr, endDateTimeStr).then((ventas) => {
        self.ventas = ventas;
        self.selectedDates = dates;
        self.showTableLoadingMsg = false;
      });
    },
  },
  beforeMount() {
    // mounted() {
    this.defineHeaders();
    this.showTableLoadingMsg = true;
    this.fetchSales();
  },
};
</script>

<style scoped>
.user-input {
  font-size: 13.5px;
}
.ventas__container {
  margin-top: 10px;
}

.ventas__table__actions-col {
  display: flex;
  flex-wrap: nowrap;
}
</style>